const _excluded = ["isOpen", "onRequestClose", "onBackClick", "title", "subtitle", "id", "headerIconButtonVariant", "primaryButtonProps", "secondaryButtonProps", "showDividers", "showOverlay", "stackCTAs", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "hasPadding", "themeProps", "contentBgColor"];
function cov_1r3isrjpns() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx";
  var hash = "f4b1bd4e37db8716ff214be5caedf239beea91b8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/Popover.tsx",
    statementMap: {
      "0": {
        start: {
          line: 76,
          column: 25
        },
        end: {
          line: 76,
          column: 28
        }
      },
      "1": {
        start: {
          line: 77,
          column: 27
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "2": {
        start: {
          line: 82,
          column: 27
        },
        end: {
          line: 86,
          column: 1
        }
      },
      "3": {
        start: {
          line: 189,
          column: 47
        },
        end: {
          line: 336,
          column: 1
        }
      },
      "4": {
        start: {
          line: 210,
          column: 2
        },
        end: {
          line: 210,
          column: 32
        }
      },
      "5": {
        start: {
          line: 212,
          column: 25
        },
        end: {
          line: 212,
          column: 91
        }
      },
      "6": {
        start: {
          line: 213,
          column: 20
        },
        end: {
          line: 213,
          column: 63
        }
      },
      "7": {
        start: {
          line: 215,
          column: 37
        },
        end: {
          line: 215,
          column: 47
        }
      },
      "8": {
        start: {
          line: 217,
          column: 45
        },
        end: {
          line: 233,
          column: 3
        }
      },
      "9": {
        start: {
          line: 235,
          column: 45
        },
        end: {
          line: 246,
          column: 3
        }
      },
      "10": {
        start: {
          line: 248,
          column: 23
        },
        end: {
          line: 269,
          column: 3
        }
      },
      "11": {
        start: {
          line: 271,
          column: 2
        },
        end: {
          line: 335,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 189,
            column: 47
          },
          end: {
            line: 189,
            column: 48
          }
        },
        loc: {
          start: {
            line: 209,
            column: 6
          },
          end: {
            line: 336,
            column: 1
          }
        },
        line: 209
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 190,
            column: 2
          },
          end: {
            line: 190,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 190,
            column: 11
          },
          end: {
            line: 190,
            column: 16
          }
        }],
        line: 190
      },
      "1": {
        loc: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 199,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 199,
            column: 17
          },
          end: {
            line: 199,
            column: 21
          }
        }],
        line: 199
      },
      "2": {
        loc: {
          start: {
            line: 200,
            column: 2
          },
          end: {
            line: 200,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 200,
            column: 16
          },
          end: {
            line: 200,
            column: 20
          }
        }],
        line: 200
      },
      "3": {
        loc: {
          start: {
            line: 201,
            column: 2
          },
          end: {
            line: 201,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 201,
            column: 14
          },
          end: {
            line: 201,
            column: 19
          }
        }],
        line: 201
      },
      "4": {
        loc: {
          start: {
            line: 205,
            column: 2
          },
          end: {
            line: 205,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 205,
            column: 15
          },
          end: {
            line: 205,
            column: 19
          }
        }],
        line: 205
      },
      "5": {
        loc: {
          start: {
            line: 212,
            column: 25
          },
          end: {
            line: 212,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 33
          },
          end: {
            line: 212,
            column: 64
          }
        }, {
          start: {
            line: 212,
            column: 67
          },
          end: {
            line: 212,
            column: 91
          }
        }],
        line: 212
      },
      "6": {
        loc: {
          start: {
            line: 213,
            column: 20
          },
          end: {
            line: 213,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 213,
            column: 37
          },
          end: {
            line: 213,
            column: 41
          }
        }, {
          start: {
            line: 213,
            column: 44
          },
          end: {
            line: 213,
            column: 63
          }
        }],
        line: 213
      },
      "7": {
        loc: {
          start: {
            line: 218,
            column: 16
          },
          end: {
            line: 218,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 218,
            column: 33
          },
          end: {
            line: 218,
            column: 58
          }
        }, {
          start: {
            line: 218,
            column: 61
          },
          end: {
            line: 218,
            column: 77
          }
        }],
        line: 218
      },
      "8": {
        loc: {
          start: {
            line: 245,
            column: 21
          },
          end: {
            line: 245,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 245,
            column: 35
          },
          end: {
            line: 245,
            column: 59
          }
        }, {
          start: {
            line: 245,
            column: 62
          },
          end: {
            line: 245,
            column: 75
          }
        }],
        line: 245
      },
      "9": {
        loc: {
          start: {
            line: 303,
            column: 9
          },
          end: {
            line: 315,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 303,
            column: 10
          },
          end: {
            line: 303,
            column: 21
          }
        }, {
          start: {
            line: 303,
            column: 25
          },
          end: {
            line: 303,
            column: 39
          }
        }, {
          start: {
            line: 303,
            column: 43
          },
          end: {
            line: 303,
            column: 48
          }
        }, {
          start: {
            line: 303,
            column: 52
          },
          end: {
            line: 303,
            column: 60
          }
        }, {
          start: {
            line: 304,
            column: 10
          },
          end: {
            line: 314,
            column: 12
          }
        }],
        line: 303
      },
      "10": {
        loc: {
          start: {
            line: 317,
            column: 16
          },
          end: {
            line: 317,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 317,
            column: 29
          },
          end: {
            line: 317,
            column: 30
          }
        }, {
          start: {
            line: 317,
            column: 33
          },
          end: {
            line: 317,
            column: 34
          }
        }],
        line: 317
      },
      "11": {
        loc: {
          start: {
            line: 321,
            column: 9
          },
          end: {
            line: 332,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 321,
            column: 10
          },
          end: {
            line: 321,
            column: 28
          }
        }, {
          start: {
            line: 321,
            column: 32
          },
          end: {
            line: 321,
            column: 52
          }
        }, {
          start: {
            line: 322,
            column: 10
          },
          end: {
            line: 331,
            column: 13
          }
        }],
        line: 321
      },
      "12": {
        loc: {
          start: {
            line: 323,
            column: 13
          },
          end: {
            line: 323,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 323,
            column: 13
          },
          end: {
            line: 323,
            column: 25
          }
        }, {
          start: {
            line: 323,
            column: 29
          },
          end: {
            line: 323,
            column: 40
          }
        }],
        line: 323
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f4b1bd4e37db8716ff214be5caedf239beea91b8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r3isrjpns = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1r3isrjpns();
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactModal from 'react-modal';
import { css, Global } from '@emotion/react';
import { Box, Divider } from "../../core/index.mjs";
import { useTheme } from "../../system/theme/index.mjs";
import { colors as colorKeys } from "../../theme/novo/index.mjs";
import { ThemedLite } from "../../theme/ODThemeLite.mjs";
import { getNavigationBarTitleId } from "./NavigationBar.mjs";
import { ModalFooter, ModalHeader, useDisabledBodyScroll } from "./shared.mjs";

// For the CTA props, `variant` is not allowed. `analyticsName` and `aria-label` are optional because we provide defaults

// To meet accessibility standards, the Popover component must receive either title, aria-labelledby, or aria-label.

const CLOSE_TIMEOUT_MS = (cov_1r3isrjpns().s[0]++, 500);
const CONTENT_CLASS_NAME = (cov_1r3isrjpns().s[1]++, {
  base: 'BricksPopover__Content',
  afterOpen: 'BricksPopover__Content--after-open',
  beforeClose: 'BricksPopover__Content--before-close'
});
const OVERLAY_CLASS_NAME = (cov_1r3isrjpns().s[2]++, {
  base: 'BricksPopover__Overlay',
  afterOpen: 'BricksPopover__Overlay--after-open',
  beforeClose: 'BricksPopover__Overlay--before-close'
});

/**
 * Popovers are modal patterns best used for single-step tasks like changing a
 * single filter. We also use them to show small amounts of information.
 *
 * Content Sizing
 *
 *
 * ------------------
 *
 * Popovers change size based on their content. On mobile, they will expand up
 * to 48px from the edges of the screen. On larger screens, they will
 * accommodate content up to 960x530px. Make sure to design the content to be
 * responsive. Popovers do not allow for scrolling. If your content is larger
 * than the maximum dimensions allowed, used a FullScreenModal instead.
 *
 * Header and Footer Props
 *
 *
 * ---------------------------
 *
 * Popovers render header and footer content based on props:
 *
 * *   The close icon renders when you pass `onRequestClose` (this is required)
 *
 * *   A back icon renders when you pass `onBackClick`
 *
 * *   Dividers between the header, children, and footer render when you pass
 * `showDividers={true}`
 *
 * *   A primary button renders when you pass `primaryButtonProps` (these are
 * the props you want to pass to the Button component, including `children` and
 * `onClick`)
 *
 * *   A secondary button renders when you pass `secondaryButtonProps` (same as
 * above)
 *
 * *   If the text for the primary and secondary buttons is long, pass
 * `stackCTAs={true}` to render one on top of the other
 *
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * It's required to pass one of these props: `title`, `aria-labelledby`, or
 * `aria-label`. We recommend passing `title` (if you do that, the component
 * will render the appropriate `aria-labelledby` attribute for you).
 *
 * <Popover title="My Popover"> <Text>Content</Text> </Popover>
 *
 * <Popover aria-labelledby="popover-heading"> <Box> <Text
 * id="popover-heading">Heading</Text> <Text>Content</Text> </Box> </Popover>
 *
 * // Acceptable, but try to avoid because there's no visible text label
 * <Popover aria-label="Popover with Content"> <Image /> </Popover>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * If you pass `analyticsName`, the Popover component will track:
 *
 * *   Modal impression events, if you also pass `trackBoxImpression={true}`
 *
 * *   `boxViewEvent: { targetName: "example" }`
 *
 * *   Back button events, if you also pass `onBackClick`
 *
 * *   `buttonViewEvent: { targetName: "example-back" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-back" }`
 *
 * *   `buttonClickEvent: { targetName: "example-back" }`,
 *
 * *   Close button events
 *
 * *   `buttonViewEvent: { targetName: "example-close" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-close" }`
 *
 * *   `buttonClickEvent: { targetName: "example-close" }`
 *
 * *   Primary button events, if you also pass `primaryButtonProps`
 *
 * *   `buttonViewEvent: { targetName: "example-primary-button" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-primary-button" }`
 *
 * *   `buttonClickEvent: { targetName: "example-primary-button" }`
 *
 * *   Secondary button events, if you also pass `secondaryButtonProps`
 *
 * *   `buttonViewEvent: { targetName: "example-secondary-button" }`
 *
 * *   `buttonHoverEvent: { targetName: "example-secondary-button" }`
 *
 * *   `buttonClickEvent: { targetName: "example-secondary-button" }`
 */
cov_1r3isrjpns().s[3]++;
export const Popover = _ref => {
  let {
      isOpen = (cov_1r3isrjpns().b[0][0]++, false),
      onRequestClose,
      onBackClick,
      title,
      subtitle,
      id,
      headerIconButtonVariant,
      primaryButtonProps,
      secondaryButtonProps,
      showDividers = (cov_1r3isrjpns().b[1][0]++, true),
      showOverlay = (cov_1r3isrjpns().b[2][0]++, true),
      stackCTAs = (cov_1r3isrjpns().b[3][0]++, false),
      analyticsName,
      trackBoxImpression,
      trackButtonImpressions,
      hasPadding = (cov_1r3isrjpns().b[4][0]++, true),
      themeProps,
      contentBgColor
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1r3isrjpns().f[0]++;
  cov_1r3isrjpns().s[4]++;
  useDisabledBodyScroll(isOpen);
  const ariaLabelledBy = (cov_1r3isrjpns().s[5]++, title ? (cov_1r3isrjpns().b[5][0]++, getNavigationBarTitleId({
    id
  })) : (cov_1r3isrjpns().b[5][1]++, props['aria-labelledby']));
  const ariaLabel = (cov_1r3isrjpns().s[6]++, ariaLabelledBy ? (cov_1r3isrjpns().b[6][0]++, null) : (cov_1r3isrjpns().b[6][1]++, props['aria-label']));
  const {
    shadows,
    radii,
    colors
  } = (cov_1r3isrjpns().s[7]++, useTheme());
  const contentStyles = (cov_1r3isrjpns().s[8]++, {
    background: contentBgColor ? (cov_1r3isrjpns().b[7][0]++, colorKeys[contentBgColor]) : (cov_1r3isrjpns().b[7][1]++, colors.neutrals0),
    WebkitOverflowScrolling: 'touch',
    outline: 'none',
    border: 'none',
    position: 'absolute',
    inset: 'auto',
    padding: 0,
    boxShadow: shadows.z2,
    borderRadius: radii.semiRounded,
    display: 'flex',
    flexDirection: 'column',
    // Popovers do not allow scrolling. Use full-screen modal if content overflows.
    overflow: 'hidden',
    maxHeight: 'calc(100vh - 48px)',
    maxWidth: 'calc(100vw - 48px)'
  });
  const overlayStyles = (cov_1r3isrjpns().s[9]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999,
    backgroundColor: showOverlay ? (cov_1r3isrjpns().b[8][0]++, 'rgba(34, 34, 34, 0.60)') : (cov_1r3isrjpns().b[8][1]++, 'transparent')
  });
  const globalStyles = (cov_1r3isrjpns().s[10]++, /*#__PURE__*/css(".", OVERLAY_CLASS_NAME.base, "{opacity:0;transition:opacity ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{opacity:1;}.", OVERLAY_CLASS_NAME.beforeClose, "{opacity:0;}.", CONTENT_CLASS_NAME.base, "{transform:translateY(10%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(10%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
  cov_1r3isrjpns().s[11]++;
  return /*#__PURE__*/React.createElement(ReactModal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: showOverlay,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/React.createElement(Global, {
    styles: globalStyles
  }), /*#__PURE__*/React.createElement(ThemedLite, themeProps, ((cov_1r3isrjpns().b[9][0]++, onBackClick) || (cov_1r3isrjpns().b[9][1]++, onRequestClose) || (cov_1r3isrjpns().b[9][2]++, title) || (cov_1r3isrjpns().b[9][3]++, subtitle)) && (cov_1r3isrjpns().b[9][4]++, /*#__PURE__*/React.createElement(ModalHeader, {
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onBackClick: onBackClick,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id,
    showDivider: showDividers,
    headerIconButtonVariant: headerIconButtonVariant
  })), /*#__PURE__*/React.createElement(Box, {
    p: hasPadding ? (cov_1r3isrjpns().b[10][0]++, 5) : (cov_1r3isrjpns().b[10][1]++, 0),
    maxWidth: "960px",
    maxHeight: "530px",
    overflow: "hidden"
  }, props.children), ((cov_1r3isrjpns().b[11][0]++, primaryButtonProps) || (cov_1r3isrjpns().b[11][1]++, secondaryButtonProps)) && (cov_1r3isrjpns().b[11][2]++, /*#__PURE__*/React.createElement(React.Fragment, null, (cov_1r3isrjpns().b[12][0]++, showDividers) && (cov_1r3isrjpns().b[12][1]++, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(ModalFooter, {
    stackCTAs: stackCTAs,
    primaryButtonProps: primaryButtonProps,
    secondaryButtonProps: secondaryButtonProps,
    analyticsName: analyticsName
  })))));
};
export default Popover;